import { render, staticRenderFns } from "./TheHome.vue?vue&type=template&id=510b9369&"
import script from "./TheHome.vue?vue&type=script&lang=ts&"
export * from "./TheHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports